function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M19.108 116.87a4.676 4.676 0 1 0 9.351 0 4.676 4.676 0 0 0-9.351 0M2.543 56.196H26.07V32.668H2.543zm113.625 60.959a4.42 4.42 0 1 0 8.84-.002 4.42 4.42 0 0 0-8.84.002",
  fill: "#BEFFFC"
}), React.createElement("path", {
  d: "M92.31 118.783c1.048 15.695 14.11 28.102 30.073 28.102 16.646 0 30.14-13.495 30.14-30.14 0-16.061-12.562-29.188-28.397-30.091m-4.516.076c-14.806 1.351-26.517 13.409-27.324 28.365m6.443-.253c.901-11.308 9.765-20.408 20.967-21.676",
  stroke: "#2B3787",
  strokeWidth: 0.4
}), React.createElement("path", {
  d: "M124.52 93.11c12.086 1.085 21.59 11.272 21.59 23.635 0 13.084-10.643 23.727-23.727 23.727-12.261 0-22.38-9.346-23.605-21.29m40.936 22.661l16.132 16.132a4.404 4.404 0 1 0 6.228-6.228l-15.956-15.956",
  stroke: "#2B3787",
  strokeWidth: 0.4
}), React.createElement("path", {
  d: "M117.867 116.805a4.415 4.415 0 1 0 8.83-.001 4.415 4.415 0 0 0-8.83.001zm-8.583 6.438v6.805h6.805m.001-27.221h-6.806v6.805m27.221-.001v-6.805H129.7m0 27.221h6.805v-6.805",
  stroke: "#2B3787",
  strokeWidth: 0.4
}), React.createElement("path", {
  d: "M115.627 37.397a5.119 5.119 0 1 0 10.238-.002 5.119 5.119 0 0 0-10.238.002",
  fill: "#BEFFFC"
}), React.createElement("path", {
  stroke: "#2B3787",
  strokeWidth: 0.4,
  d: "M5.209 56.196h23.527V32.668H5.209zM38.914 37.34H87.96m-49.046 6.5H76.71m-37.796 6.5H84.71M1.2 111.468a4.676 4.676 0 1 0 9.352 0 4.676 4.676 0 0 0-9.352 0zm19.742 5.402a4.676 4.676 0 1 0 9.352 0 4.676 4.676 0 0 0-9.352 0zm28.413-30.893a4.676 4.676 0 1 0 9.352 0 4.676 4.676 0 0 0-9.352 0zm19.917 3.535a4.675 4.675 0 1 0 9.352 0 4.677 4.677 0 0 0-9.352 0zM127.33 37.21a4.676 4.676 0 1 0-9.353 0 4.676 4.676 0 0 0 9.352 0m28.667-27.333a4.676 4.676 0 1 0-9.353-.002 4.676 4.676 0 0 0 9.353.002M10.032 113.449l10.91 2.338m8.67-1.461L50.243 88.74m8.377-1.85l10.619 2.046m50.631-47.731L77.13 86.11"
}), React.createElement("path", {
  d: "M122.084 42.43v69.538",
  stroke: "#2B3787",
  strokeWidth: 0.4,
  strokeDasharray: "1,5,1,5,1,5"
}), React.createElement("path", {
  d: "M23.395 38.006L11.08 50.321m0-12.315l12.315 12.315m103.148-15.52l21.332-22.333m-124.166 102.5l3.938 3.938m-3.938 0l3.938-3.938m93.229-79.875l3.938 3.938m-3.938-.001l3.938-3.937m-4.23 79.625l3.938 3.938m-3.938 0l3.938-3.938",
  stroke: "#2B3787",
  strokeWidth: 0.4
}), React.createElement("path", {
  d: "M30.294 116.87h87.04",
  stroke: "#2B3787",
  strokeWidth: 0.4,
  strokeDasharray: "1,5,1,5,1,5"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 165 165",
    width: "1em",
    height: "1em"
  }, props), _ref);
};

export default SvgComponent;


// WEBPACK FOOTER //
// ./src/components/sections/ourVirtualExperts/flow/solution.svg